import Config from '../../config';
import { NO_FLAG } from '../constants';
import { QueryKeys, useCustomQuery } from './index';
import { useSelector } from 'react-redux';
import { isInitialDataLoadedSelector } from '../store/selectors';

export const useMaintenanceAndLockFlag = ({ refetchInterval }: { refetchInterval?: number } = {}) => {
  const isInitialDataLoaded = useSelector(isInitialDataLoadedSelector);
  return useCustomQuery<{ maintenanceFlag: string, lockFlag: string }>(
    [QueryKeys.clientAdministration.MaintenanceFlag, QueryKeys.clientAdministration.LockFlag],
    {
      url: Config.endpoints.FETCH_MAINTENANCE_AND_LOCK_FLAG,
      errorMessage: 'Fetching maintenance flag failed',
      defaultData: { maintenanceFlag: NO_FLAG, lockFlag: NO_FLAG },
      refetchInterval,
      enabled: isInitialDataLoaded,
    }
  );
};
